import base_http from './base';
import Router from '@/js/router.js';

const http = function (args) {
  const instance = base_http(args);

  return Object.assign({ user: {} }, instance, {
    getBaseUrl: function () {
      const host = window.location.host;
      const subdomain = this.user.subdomain || 'user';

      // For staging environment
      if (host.includes('vintanalabs.com')) {
        return `${window.location.protocol}//staging-${subdomain}-invoice-gateway.vintanalabs.com/user_api`;
      }

      // For local IP-based development
      if (host === '127.0.0.1' || host === 'localhost') {
        return `${window.location.protocol}//${host}/user_api`;
      }

      // For local domain-based development
      return `${window.location.protocol}//${subdomain}.invoice-gateway.test/user_api`;
    },

    setUser: function (user) {
      this.user = user;
      return this;
    },

    errorHandler: (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          Router.replace({ name: 'user.login' });
        }
      } else {
        console.error('Error', error.message);
      }
      return Promise.reject(error);
    },
  });
};

export default http;
